import Cookies from 'js-cookie';
import { DateTime } from 'luxon';

import store from '@/store';

function updateAuthState() {
  console.log('updateAuthState');

  // 로컬 스토리지에 로그인 상태가 있는지 확인
  const isLoginLocal = localStorage.getItem('isLogin');

  console.log('isLoginLocal', isLoginLocal);

  // 로컬 스토리지에 로그인 상태가 없으면 로그인 상태 업데이트
  if (!isLoginLocal) return store.dispatch('getLoginState');

  // 쿠키에 로그인 상태가 있는지 확인
  const isLoginCookie = Cookies.get('isLogin');

  console.log('isLoginCookie', isLoginCookie);

  // 쿠키에 로그인 상태가 없으면 로그인 상태 업데이트
  if (!isLoginCookie) return store.dispatch('getLoginState');

  // 쿠키와 로컬 스토리지의 로그인 상태 날짜 비교
  const isLoginCookieDate = DateTime.fromISO(isLoginCookie);
  const isLoginLocalDate = DateTime.fromISO(isLoginLocal);

  console.log('isLoginCookieDate', isLoginCookieDate);
  console.log('isLoginLocalDate', isLoginLocalDate);

  // 로컬 스토리지와 쿠키의 로그인 상태가 다르면 로그인 상태 업데이트
  if (isLoginCookieDate.diff(isLoginLocalDate).toMillis() > 0) return store.dispatch('getLoginState');

  return;
}

export function authStateManager() {
  document.addEventListener('visibilitychange', () => {
    // 탭이 비활성화되면 리턴
    if (document.hidden) return;

    updateAuthState();
  });

  // 또는 window의 focus/blur 이벤트 사용
  window.addEventListener('focus', () => {
    updateAuthState();
  });

  // window.addEventListener('blur', () => {
  //   console.log('창이 포커스를 잃음');
  // });
}
